import * as React from "react";
import {DynamicDialog, DynamicDialogProps, DynamicDialogState} from "shared/controls/Dialogs/core/DynamicDialog";
import {DialogProps} from "shared/controls/Dialogs/core/Dialog";
import {ReactNode} from "react";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faCog} from "@fortawesome/free-solid-svg-icons/faCog";
import {library} from "@fortawesome/fontawesome-svg-core";
import {PDFDocumentOptions} from "PageBuilder/pagebuilder/PDFDocument.Options";
import {FieldControlOptions} from "PageBuilder/pagebuilder/Controls/ControlsList/FieldControl.Options";
import {PDFControlBaseOptions} from "InternalShared/PageBuilder/Controls/Core/PDFControlBase.Options";
import {PDFControlBase} from "InternalShared/PageBuilder/Controls/Core/PDFControlBase";
import {PDFControlGenerator} from "InternalShared/PageBuilder/Controls/Core/Generators/PDFControlGenerator";
import {SimpleTextProperty} from "InternalShared/PageBuilder/Controls/Properties/SimpleTextProperty";
import {TextProperty} from "InternalShared/PageBuilder/Controls/Properties/TextProperty";
import {SearchableSelect} from "shared/controls/SingleInputs/SearchableSelect/SearchableSelect";
import {PropertyBase} from "InternalShared/PageBuilder/Controls/Properties/PropertyBase";
import {ControlTypeEnum} from "PageBuilder/pagebuilder/Controls/NormalPDFControlFactory";
import {FieldDropdownProperty} from "InternalShared/PageBuilder/Controls/Properties/FieldDropdownProperty";
import {FieldControl} from "PageBuilder/pagebuilder/Controls/ControlsList/FieldControl";
import {faSearch} from "@fortawesome/free-solid-svg-icons/faSearch";
import {previewType} from "PageBuilder/pagebuilder/services/PageService";
import {ToastService} from "shared/utilities/services/ToastService";


library.add(faCog);
library.add(faSearch);
export class TemplateManagerDialog extends DynamicDialog<TemplateManagerDialogProps, TemplateManagerDialogState> {
    static defaultProps: Partial<TemplateManagerDialogProps> = {
        FormIdAlreadyDefined:false
    };
    public Fields:{Field:PDFControlBase,Editor:PropertyBase,OriginalId:string,OriginalSubType:string}[];
    constructor(props: TemplateManagerDialogProps) {
        super(props);
        this.Fields=[];
        for(let page of this.props.DocumentOptions.Pages)
            for(let currentField of page.Fields)
            {
                if(currentField.HideFromTemplateDesigner)
                    continue;
                let field=PDFControlGenerator.GetControl(null,currentField.Type);
                field.PseudoInitializeWithOptions(currentField);
                let editor=field.GetValueEditor();
                this.Fields.push({
                    Field:field,
                    Editor:editor,
                    OriginalId:field.Options.Id.toString(),
                    OriginalSubType:(field.Options as FieldControlOptions).SubType

                });

                if(field.Options.Type==ControlTypeEnum.Field.toString())
                    (editor as FieldDropdownProperty).SetFormId(props.DocumentOptions.FormId);
            }

        this.state = {
            IsOpen: true,
            SelectedForm:props.DocumentOptions.FormId
        };
    }

    GetAdditionalProperties(): DialogProps {
        return {
            Title:'Template Configuration',
            Icon:<FontAwesomeIcon icon={"cog"} />,
            Styles:{width:'80%',maxWidth:900},
            EnableCancel:false,
            EnableApply:true,
            ApplyTitle:'Done',
            FooterArea:(
                <div>
                    <button className={'rnbtn rnbtn-info'} onClick={()=>this.ExecutePreview()}><FontAwesomeIcon icon={'search'}/> Preview</button>
                    <button className={'rnbtn rnbtn-success'} onClick={()=>{

                        if(rednaoVar.FormList.find(x=>x.Id==this.state.SelectedForm) ==null)
                        {
                            ToastService.SendErrorMessage('Please select a form');
                            return;
                        }

                        this.props.DocumentOptions.DocumentSettings.CreatedFromTemplate=false; this.SendResult(this.props.DocumentOptions);}}><FontAwesomeIcon icon={'check'}/> Done</button>
                </div>
            )

        };

    }

    SubRenderer(): ReactNode {

        return(
            <div>
                {!this.props.FormIdAlreadyDefined&&
                <div>
                    <p>Looks like you just imported this template so before using it please define in which form you want to use it</p>
                    <SearchableSelect Label={'Form'} Value={this.state.SelectedForm} onChange={e=>this.ChangeForm(e)}>
                        {rednaoVar.FormList.map(x=>
                            <option key={x.Id} value={x.Id}>{x.Name}</option>
                        )}
                    </SearchableSelect>
                </div>}
                {this.state.SelectedForm != '' &&
                    <div>
                        <p style={{margin: 0, fontSize: 15}}>This template use <span
                            style={{color: 'red'}}>{this.Fields.length}</span> fields, please configure them before using
                            the template.</p>
                        <table className={'rntable'} style={{border: '1px solid #dfdfdf'}}>
                            <tbody>
                            {this.Fields.map(x =>
                                <tr>
                                    <td>{x.Field.GetLabel()}</td>
                                    <td>{x.Editor?x.Editor.renderer('1'):null}</td>
                                </tr>
                            )}
                            </tbody>
                        </table>
                    </div>
                }
            </div>
        );
    }


    private ChangeForm(e: string) {

        this.setState({SelectedForm:e as any});
        let newForm=rednaoVar.FormList.find(x=>x.Id==e);
        let newFormFields:FieldDTO[]=newForm.Fields;

        if(this.props.DocumentOptions!=null) {
            this.props.DocumentOptions.FormId = e;
            this.props.DocumentOptions.Name = newForm.Name;
        }


        let formField:{Editor:FieldDropdownProperty,Field:FieldControl,OriginalId:string,OriginalSubType:string}[]=this.Fields.filter(x=>x.Field.Options.Type==ControlTypeEnum.Field) as any;
        for(let currentFormField of formField) {
            currentFormField.Editor.SetFormId(e);

            let originalField=newFormFields.find(x=>x.Id==currentFormField.OriginalId);
            if(originalField!=null&&originalField.SubType==currentFormField.OriginalSubType)
            {
                currentFormField.Field.Options.FieldId=originalField.Id;
                continue;
            }


            let fieldWithSameSubtype=newFormFields.find(x=>x.SubType==currentFormField.OriginalSubType);
            if(fieldWithSameSubtype!=null)
            {
                currentFormField.Field.Options.FieldId=fieldWithSameSubtype.Id;
                continue;
            }


            currentFormField.Field.Options.FieldId='';
            currentFormField.Field.Options.SubType='';
        }
    }

    private ExecutePreview() {
        let previewType:previewType="fake";
        let orderNumberToPreview:number=0;


        let options=this.props.DocumentOptions.ToObject();
        let $form=jQuery(`<form style="display: none" enctype="multipart/form-data" method="post" target="_blank" action="${(window as any).ajaxurl}">
                                <input name="action" type="hidden" value="${rednaoVar._prefix}_execute_preview"/>
                                <input name="data" type="hidden"  value="" class="json" />
                                <input name="_nonce" type="hidden"  value="${rednaoVar._nonce}" />
                                <button></button>
                           </form>                           
                        `);


        jQuery('body').append($form);
        $form.find('.json').val(JSON.stringify({PageOptions:options}));
        $form.submit();
    }
}


//#region ----------------------------------------------------"State and props"------------------------------------------------------------------------------------
interface TemplateManagerDialogProps extends DynamicDialogProps {
    DocumentOptions:PDFDocumentOptions;
    FormIdAlreadyDefined:boolean;

}

interface TemplateManagerDialogState extends DynamicDialogState {
    SelectedForm:string;
}

//#endregion "My Region"